import { Mesh, BufferGeometry } from "three";
import * as utils from "three/examples/jsm/utils/SkeletonUtils.js";
import { updateGeomWithSkinnedMeshMorphAttr } from "./geometry-utils";
export const convertGltf = (gltf) => {
    const userDataUuidToNodeUuidDict = {};
    const meshToSkinnedMeshUuidDict = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gltf.scene.traverse((node) => {
        // add skinned mesh and bone uuid to user data for later mapping to cloned model instance
        if (node.isBone || node.isSkinnedMesh) {
            node.userData = {
                ...node.userData,
                uuid: node.uuid
            };
        }
    });
    // use Skeleton utils to safely clone skinned mesh (and other) models
    const clonedScene = utils.clone(gltf.scene);
    // map user data uuids to cloned node uuids (which change during cloning)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    clonedScene.traverse((node) => {
        if (node.isBone || node.isSkinnedMesh) {
            userDataUuidToNodeUuidDict[node.userData.uuid] = node.uuid;
        }
    });
    gltf.scene.updateMatrixWorld(true);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gltf.scene.traverse((node) => {
        // create baked geometry from skinned mesh
        if (node.isSkinnedMesh) {
            const skinnedMesh = node;
            skinnedMesh.skeleton.update();
            const skinnedGeom = skinnedMesh.geometry;
            const { attributes } = skinnedGeom;
            const bakedGeometry = new BufferGeometry();
            // name
            bakedGeometry.name = skinnedGeom.name;
            // index
            if (skinnedGeom.index)
                bakedGeometry.setIndex(skinnedGeom.index?.clone?.());
            // if normals are missing, compute them
            if (!attributes.normal)
                skinnedGeom.computeVertexNormals();
            // attributes
            for (const name in attributes) {
                if (name !== "position" &&
                    name !== "normal" &&
                    name !== "skinIndex" &&
                    name !== "skinWeight") {
                    const attribute = attributes[name];
                    bakedGeometry.setAttribute(name, attribute.clone());
                }
            }
            // groups
            const groups = skinnedGeom.groups;
            for (let i = 0, l = groups.length; i < l; i++) {
                const group = groups[i];
                bakedGeometry.addGroup(group.start, group.count, group.materialIndex);
            }
            updateGeomWithSkinnedMeshMorphAttr(bakedGeometry, skinnedMesh);
            // draw range
            bakedGeometry.drawRange.start = skinnedGeom.drawRange.start;
            bakedGeometry.drawRange.count = skinnedGeom.drawRange.count;
            // user data
            bakedGeometry.userData = skinnedGeom.userData;
            // create new material(s)
            const { material } = skinnedMesh;
            let newMaterial;
            if (material instanceof Array) {
                newMaterial = [];
                for (let i = 0; i < material.length; i++) {
                    newMaterial.push(material[i].clone());
                }
            }
            else
                newMaterial = material.clone();
            // add newly created mesh to mesh parent of cloned scene
            const clonedNodeUuid = userDataUuidToNodeUuidDict[node.userData.uuid];
            const clonedSceneNode = clonedScene.getObjectByProperty("uuid", clonedNodeUuid);
            // create a new mesh
            const newMesh = new Mesh();
            newMesh.name = 'hello';
            clonedSceneNode.userData = { origUuid: clonedSceneNode.uuid };
            // fill mesh to meshToSkinnedMeshUuid dict 
            meshToSkinnedMeshUuidDict[newMesh.uuid] = clonedNodeUuid;
            newMesh.copy(clonedSceneNode);
            newMesh.userData = { origUuid: newMesh.uuid };
            newMesh.geometry = bakedGeometry;
            //newMesh.material = newMaterial;
            clonedSceneNode?.parent?.add?.(newMesh);
            newMesh.visible = false;
        }
    });
    // hide skinnedMeshes and bones model scene (needed in future milestones for animation)
    for (const userDataUuid in userDataUuidToNodeUuidDict) {
        const nodeUuid = userDataUuidToNodeUuidDict[userDataUuid];
        const redundantObject = clonedScene.getObjectByProperty("uuid", nodeUuid);
        redundantObject.visible = true;
    }
    return {
        scene: clonedScene,
        animations: gltf.animations,
        meshToSkinnedMeshUuidDict
    };
};
